// extracted by mini-css-extract-plugin
module.exports = {"all_component":"LifeSaveBanner_all_component__1RdSC","life_saver":"LifeSaveBanner_life_saver__2ynnj"};